<template>
    <div>
        <div class="filterui"
            :class="{ 'filterui--actived': actived }">
            <div class="filterui__background"
                @click="clickHandler">
            </div>
            <div class="filterui__painel">
                <div class="filterui__title">
                    Filtros
                </div>
                <div class="filterui__filters">
                    <div v-for="(tag, index) in tags"
                         class="filterui__filters__item"
                         :key="index">
                        <div>{{ tag.text }}</div>
                        <Switcher :turn="tag.active"
                                  :tag="tag.text"/>
                    </div>
                </div>
                <div class="filterui__button">
                    <ButtonBox @click="clickHandler">
                      Fechar
                    </ButtonBox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonBox from '@/components/ButtonBox'
import Switcher from '@/components/Switcher'
export default {
    name: 'filterui',
    components: {
        ButtonBox,
        Switcher,
    },
    props: {
        actived: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters(['tags'])
    },
    methods: {
        clickHandler() {
            this.$store.dispatch('turnFilterUI', false)
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.filterui {
    position: fixed;
    bottom: -100%;
    left: 0;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 1fr;
    @media(max-width: $max-sm) and (min-width: $min-sm) {
      width: 60rem;
      left: 50%;
      margin-left:-30rem;
    }
    @media(min-width: $min-md) {
        display: none;
    }

    &--actived {
        bottom: 0;
        transition: bottom .1s;
    }

    &__painel {
        border: .7rem solid #fff;
        border-bottom: 0;
        border-top: 0;
        width: 100%;
        border-top-left-radius: 2rem;
        border-top-right-radius: 2rem;
        height: 48.2rem;
        background: #F5F5F5;
        color: #979797;
        display: grid;
        row-gap: 4rem;
        grid-template-rows: 3.5rem 28.2rem auto;
        @media(max-width: $max-sm) and (min-width: $min-sm) {
          border-bottom-left-radius: 2rem;
          border-bottom-right-radius: 2rem;
        }
    }

    &__title {
        text-transform: uppercase;
        font-size: 1.5rem;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items:flex-end;
    }

    &__filters {
        display: flex;
        justify-content: center;
        flex-direction: column;
        &__item {
            padding: .9rem 1.7rem;
            font-size: 1.8rem;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    &__button {
        padding: 0 4.6rem;
    }
}
</style>
